import React from "react";
import AppLayout from "components/layout/AppLayout";
import NotFound from "pages/NotFound";
import Otp from "pages/InitScreen/Otp.screen";
import AllPolicy from "pages/AllPolicy/AllPolicy";
import InsurancePolicyForm from "pages/UploadPolicy/UploadPolicy";
import { DocumentScanner } from "pages/AllPolicy/components/DocumentScanner";
import BenefitSummary from "pages/benefitSummary/benefitSummary";
import { HealthPolicyPreview } from "pages/healthPolicyPreview/HealthPolicyPreview";
import { PaymentSuccess } from "pages/paymentSuccess/PaymentSuccess";
import HealthResult from "pages/result/HealthResult";
import Login from "pages/InitScreen/Login.screen";
import ReviewPolicy from "pages/ReviewPolicy/ReviewPolicy";
import UploadDoc from "pages/UploadPolicy/components/UploadImage";
import LifePreview from "pages/lifePreview/LifePreview";
import Questionare from "pages/Questionare/Questionare";
import LifeResult from "pages/result/LifeResult";
import UnexpectedErrorPage from "pages/UnexpectedError";
import RecommendationEngine from "pages/recommendationEngine/RecommendationEngine";
import RecommendationBenefitSummaryV1 from "pages/benefitSummary/recommendationBenefitSummaryV1";
import { requireAuth } from "routes/guards/recommendationGuard";
import MotorPreview from "pages/MotorPolicy/MotorPreview";
import MotorReview from "pages/MotorPolicy/MotorReview";
import MotorbenefitSummary from "pages/benefitSummary/motorbenefitSummary/motorbenefitSummary";
import MotorResult from "pages/result/MotorResult";

interface RouteType {
  path: string;
  element?: React.ReactNode;
  privateRoute: boolean;
  errorElement?: React.ReactNode;
  children?: RouteType[];
  index?: any;
  loader?: any;
}

const routes: RouteType[] = [
  {
    path: "/",
    privateRoute: false
  },
  {
    index: true,
    path: "",
    errorElement: <UnexpectedErrorPage />,
    element: (
      <AppLayout>
        <Login />
      </AppLayout>
    ),
    privateRoute: false
  },
  {
    index: true,
    path: "/otp",
    errorElement: <UnexpectedErrorPage />,
    element: (
      <AppLayout>
        <Otp />
      </AppLayout>
    ),
    privateRoute: false
  },
  {
    path: "/kyp",
    privateRoute: true,
    errorElement: <UnexpectedErrorPage />,
    children: [
      {
        index: true,
        path: "policies",
        element: (
          <AppLayout>
            <AllPolicy />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        path: "upload-policy",
        privateRoute: true,
        children: [
          {
            index: true,
            path: "",
            element: (
              <AppLayout>
                <InsurancePolicyForm />
              </AppLayout>
            ),
            privateRoute: false
          },
          {
            path: "docs/:pageType",
            element: (
              <AppLayout>
                <UploadDoc />
              </AppLayout>
            ),
            privateRoute: false
          }
        ]
      },
      {
        index: true,
        path: "scanning-policy/:policyId",
        element: (
          <AppLayout>
            <DocumentScanner />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "benefit-summary/:policyId",
        element: (
          <AppLayout>
            <BenefitSummary />
          </AppLayout>
        ),
        privateRoute: false
      },

      {
        index: true,
        path: "motor-benefit-summary/:policyId",
        element: (
          <AppLayout>
            <MotorbenefitSummary />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "policy-preview/:policyId",
        element: (
          <AppLayout>
            <HealthPolicyPreview />
          </AppLayout>
        ),
        privateRoute: false
      },

      {
        index: true,
        path: "life-preview/:policyId",
        element: (
          <AppLayout>
            <LifePreview />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "questionare/:policyId",
        element: (
          <AppLayout>
            <Questionare />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "review-policy/:policyId",
        element: (
          <AppLayout>
            <ReviewPolicy />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "payment-success/:policyId",
        element: (
          <AppLayout>
            <PaymentSuccess />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "kyp-health-result/:policyId",
        element: (
          <AppLayout>
            <HealthResult />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "kyp-life-result/:policyId",
        element: (
          <AppLayout>
            <LifeResult />
          </AppLayout>
        ),
        privateRoute: false
      },

      {
        index: true,
        path: "kyp-motor-result/:policyId",
        element: (
          <AppLayout>
            <MotorResult />
          </AppLayout>
        ),
        privateRoute: false
      },

      {
        index: true,
        path: "motor-preview/:policyId",
        element: (
          <AppLayout>
            <MotorPreview />
          </AppLayout>
        ),
        privateRoute: false
      },

      {
        index: true,
        path: "motor-review/:policyId",
        element: (
          <AppLayout>
            <MotorReview />
          </AppLayout>
        ),
        privateRoute: false
      }
    ]
  },
  {
    path: "/recommendation",
    privateRoute: true,
    loader: requireAuth,
    errorElement: <UnexpectedErrorPage />,
    children: [
      {
        index: true,
        path: "products",
        element: (
          <AppLayout>
            <RecommendationEngine />
          </AppLayout>
        ),
        privateRoute: false
      },
      {
        index: true,
        path: "benefit-summary/:productId",
        element: (
          <AppLayout>
            <RecommendationBenefitSummaryV1 />
          </AppLayout>
        ),
        privateRoute: true
      }
    ]
  },
  {
    path: "*",
    element: <NotFound />,
    privateRoute: false
  }
];

export default routes;
